import { useRef } from "react";
import { useAppSelector } from "redux/hooks";
import { formatCurrency } from "utils/formatNumber";
import { buildDateColumn } from "views/merchandise/columns/buildDateColumn";
import BulkActionsTable from "views/merchandise/tables/BulkActionsTable";

const FlightsTable = ({ data = [] }) => {
  const { marketPlace } = useAppSelector((state) => state.marketPlace);
  const columnSpecs = [buildDateColumn("startDateTime", "Start Date"), buildDateColumn("endDateTime", "End Date")];

  const TABLE_ID = "dspOrderFlightsSummary";
  const tableRef = useRef();
  return (
    <BulkActionsTable
      marketPlace={marketPlace}
      tableRef={tableRef}
      tableId={TABLE_ID}
      titleCol={{
        id: "budget",
        isStatic: true,
        Header: "Budget",
        accessor: "budget",
        style: { width: "280px" },
        width: 150,
        Cell: ({ row }) => {
          const { budgetAmount } = row._original;

          return (
            <div className="d-flex align-items-center overflow-ellipsis">
              {formatCurrency(budgetAmount, marketPlace)}
            </div>
          );
        },
        filterMethod: () => {
          return;
        },
        Filter: () => null,
      }}
      columnSpecs={columnSpecs}
      data={data}
      filterWidget={false}
      hideFilterToggleIcon={true}
      isSelectable={false}
      isExpandable={false}
      hidePagination={true}
      selectionKey={"id"}
      getSearchCriteria={() => {
        return "";
      }}
      tableRowDescription={"Flight"}
      minRows={0}
      defaultPageSize={5}
    />
  );
};

export default FlightsTable;
